"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var react_uid_1 = require("react-uid");
var outlined_input_1 = __importDefault(require("@prezzee/outlined-input"));
var filled_input_1 = __importDefault(require("@prezzee/filled-input"));
var input_1 = __importDefault(require("@prezzee/input"));
var input_label_1 = __importDefault(require("@prezzee/input-label"));
var form_helper_text_1 = __importDefault(require("@prezzee/form-helper-text"));
var form_control_1 = __importDefault(require("@prezzee/form-control"));
var variantComponent = {
    standard: input_1.default,
    filled: filled_input_1.default,
    outlined: outlined_input_1.default,
};
var TextField = (0, react_1.forwardRef)(function (_a, ref) {
    var autoComplete = _a.autoComplete, _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, className = _a.className, defaultValue = _a.defaultValue, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.error, error = _d === void 0 ? false : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, helperText = _a.helperText, idOverride = _a.id, inputRef = _a.inputRef, InputProps = _a.InputProps, label = _a.label, maxRows = _a.maxRows, minRows = _a.minRows, _f = _a.multiline, multiline = _f === void 0 ? false : _f, name = _a.name, onBlur = _a.onBlur, onChange = _a.onChange, onFocus = _a.onFocus, placeholder = _a.placeholder, _g = _a.required, required = _g === void 0 ? false : _g, rows = _a.rows, type = _a.type, value = _a.value, _h = _a.variant, variant = _h === void 0 ? 'outlined' : _h, other = __rest(_a, ["autoComplete", "autoFocus", "className", "defaultValue", "disabled", "error", "fullWidth", "helperText", "id", "inputRef", "InputProps", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "type", "value", "variant"]);
    var uid = (0, react_uid_1.useUID)();
    var id = idOverride || 'text-field-' + uid;
    var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
    var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
    var InputElement = variantComponent[variant];
    var dynamicProps = {};
    if (variant === 'outlined') {
        dynamicProps.label = label;
    }
    return ((0, jsx_runtime_1.jsxs)(form_control_1.default, __assign({ className: className, disabled: disabled, error: error, fullWidth: fullWidth, ref: ref, required: required, variant: variant }, other, { children: [label != null && label !== '' && ((0, jsx_runtime_1.jsx)(input_label_1.default, __assign({ id: inputLabelId, htmlFor: id }, { children: label }))), (0, jsx_runtime_1.jsx)(InputElement, __assign({ "aria-describedby": helperTextId, autoComplete: autoComplete, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, fullWidth: fullWidth, multiline: multiline, name: name, rows: rows, maxRows: maxRows, minRows: minRows, type: type, value: value, id: id, ref: inputRef, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder }, dynamicProps, InputProps)), (helperText || typeof error === 'string') && ((0, jsx_runtime_1.jsx)(form_helper_text_1.default, __assign({ id: helperTextId }, { children: typeof error === 'string' ? error : helperText && helperText })))] })));
});
TextField.displayName = 'PrezzeeTextField';
exports.default = TextField;
//# sourceMappingURL=TextField.js.map